import React from "react";
import { Page } from "../../activities/AppPage";
import useMixin from "../../hooks/useMixin";
import { isLoading } from "../../Loading";
import { ChatRoomId } from "../../messages";
import { STRINGS } from "../../strings";
import { AppState } from "../../system/AppState";
import { ChatSystemStrategies } from "../../system/AppState/ChatState";
import { translate } from "../../translate";
import { ChatsListContainer } from "../ChatsListContainer";
import LoadingScaffold from "../LoadingScaffold";
import ScaffoldTitle from "../Scaffold/components/ScaffoldTitle";
import Scaffold from "../Scaffold/Scaffold";

type Props = {
  appState: AppState;
  chatSystemStrategies: ChatSystemStrategies;
  onClickGoBack: () => void;
  onRequestNavigate: (page: Page) => void;
};

export default function OtherAgenciesChatActivity(props: Props) {
  const mixin = useMixin(props.appState);

  const handleClickChatRoom = (chatRoomId: ChatRoomId) => {
    props.onRequestNavigate({
      type: "Chat",
      chatRoomId: chatRoomId,
      linkToVisit: true,
    });
  };

  const handleClickChatPlaceholderButton = () => {
    props.onRequestNavigate({
      type: "MyAgencies",
      addAgency: true,
      resetOnFinish: false,
      popOnNotWorkingWithAgency: false,
    });
  };

  if (isLoading(mixin.appVisitsState) || isLoading(mixin.appAgenciesState)) {
    return <LoadingScaffold title={translate(STRINGS.CHAT)} onClickGoBack={props.onClickGoBack} />;
  }

  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.CHAT)} />}
      onClickGoBack={props.onClickGoBack}
    >
      <ChatsListContainer
        chats={mixin.appChatState}
        chatSystemStrategies={props.chatSystemStrategies}
        agencies={mixin.appAgenciesState}
        visits={mixin.appVisitsState.visits}
        onChatRoomClick={handleClickChatRoom}
        onPlaceHolderBtnClick={handleClickChatPlaceholderButton}
      />
    </Scaffold>
  );
}
